export const primaryLangs = ['de', 'fr', 'it', 'en'];
